﻿import Device from '../utils/device';
import Cookie from '../utils/cookie';
import Trigger from '../event/trigger';

class ToastItem {
    constructor(el, index) {
        this.render(el, index);
    }

    button_CLICK(event, params) {
        Cookie.instance.create(this.cookieName, 1, 7);

        var delay = 0;

        for (var i = 0; i < this.items.length; i++) {
            var currentItem = this.items[i];
            TweenMax.to(currentItem, 0.4, { opacity: 0, ease: Strong.easeOut, delay: (i / 20) });

            delay = i / 20;
        }

        TweenMax.to(this.banner, 0.4, {
            'y': "100%", ease: Cubic.easeInOut, delay: delay, onComplete: function () {
                this.banner.css('display', 'none');
            }, onCompleteScope: this
        });

        TweenMax.to(this.spacer, 0.4, { 'y': "0px", ease: Cubic.easeInOut, delay: delay });

        if (!Device.instance.isScreenDesktop()) {
            TweenMax.to(this.mobileSpacer, 0.4, { 'y': "0px", ease: Cubic.easeInOut, delay: delay });
        }

        this.opened = false;
    }

    transitionIn() {
        var delay = 2;
        TweenMax.fromTo(this.banner, 0.6, { 'y': "+" + this.bannerHeight + "px" }, { "y": "0%", ease: Cubic.easeInOut, delay: delay, onComplete: this.onOpen.bind(this) });
        TweenMax.to(this.spacer, 0.6, { 'y': this.bannerHeight, ease: Cubic.easeInOut, delay: delay });

        if (!Device.instance.isScreenDesktop()) {
            TweenMax.to(this.mobileSpacer, 0.6, { 'y': this.bannerHeight, ease: Cubic.easeInOut, delay: delay });
        }

        delay = delay + 0.4;

        for (var i = 0; i < this.items.length; i++) {
            var currentItem = this.items[i];

            TweenMax.fromTo(currentItem, 0.6, { y: 20, opacity: 0 }, { y: 0, opacity: 1, ease: Strong.easeOut, delay: ((i / 20) + delay) });
        }
    }

    onOpen() {
        this.opened = true;
    }

    resize(event) {
        if (this.opened) {
            this.bannerHeight = this.banner.height();

            TweenMax.set(this.banner, { "y": "0%", ease: Cubic.easeInOut });
            TweenMax.set(this.spacer, { 'y': this.bannerHeight, ease: Cubic.easeInOut });

            if (!Device.instance.isScreenDesktop()) {
                TweenMax.set(this.mobileSpacer, { 'y': this.bannerHeight });
            }
        }
    }

    render(el, index) {
        this.element = $(el);

        this.events = {
            CLOSE_TOAST: 'CLOSE_TOAST'
        };

        this.cookieName = 'ngati_notification_closed';

        this.banner = this.element.find('*[data-component="c-toast-banner"]');
        this.items = this.element.find('*[data-component="c-toast-item"]');
        this.closeButton = this.element.find('*[data-component="c-button-rounded"]');
        this.spacer = this.element.find('*[data-component="c-toast-spacer"]');
        this.mobileSpacer = this.element.find('*[data-component="c-toast-mobile-spacer"]');

        this.banner.css('display', 'block').css('opacity', '1');
        this.bannerHeight = this.banner.height();
        this.opened = false;

        $(this.closeButton).on('click', this.button_CLICK.bind(this));

        if (Cookie.instance.read(this.cookieName)) {
            this.banner.css('display', 'none');
        } else {
            this.transitionIn();
            $(window).resize(this.resize.bind(this));
        }
    }
}

class Toast {
    constructor(selector) {
        this.all = document.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) {
        new ToastItem(el, index);
    }
}

export default Toast;
new Toast('*[data-component="c-toast"]');